import React from 'react';

interface Props {
  className?: string; // for astroturf
  people:
    | {
        html: string;
      }[]
    | null;
}

const PeopleResults = ({ className, people }: Props) => {
  return (
    <div className={className}>
      {people?.map((person, i) => (
        <div
          key={'people_' + i.toString()}
          className="a-fadeInDown panel panel-flat u-mb6x u-ph9x"
          // This component just renders html sent from the server.
          // This is less than ideal but it works for now until we can rewrite that
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: person.html }}
        />
      ))}
    </div>
  );
};

export default PeopleResults;
